import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import BrandPhilosophy from './components/BrandPhilosophy';
import DifferenceSection from './components/DifferenceSection';
import TeamSection from './components/TeamSection';
import CtaSection from '@/pages/home/components/CtaSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <AboutHero />
        <BrandPhilosophy />
        <DifferenceSection />
        <TeamSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
